import NoStoreDetailFound from "./NoStoreDetailFound";
import DynamicTabs from "../common/DynamicTabs";
import { StoreTabsConfig } from "./constants/storeTabsConfig";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const StoreView = () => {
  const { userDetails } = useSelector((state: RootState) => state.user);
  const { storeId } = userDetails || {};

  if (!storeId) return <NoStoreDetailFound />;

  return <DynamicTabs tabsConfig={StoreTabsConfig(storeId)} defaultTab={0} />;
};

export default StoreView;
